export const OrganizationDeserializer = data => {
  return {
    id: data.id,
    name: data.name,
    slug: data.slug,
    logo: data.logo,
    powered_by_logo: data.powered_by_logo,
    powered_by_url: data.powered_by_url,
    background: data.features.background_image,
    colors: data.features.colors.app,
    track_taker_session: data.track_taker_session,
    use_2FA: data.use_2FA,
    language_configuration: data.language_configuration,
  };
};

export const WebSurveyOrganizationDeserializer = data => {
  return {
    id: data.id,
    name: data.name,
    slug: data.slug,
    logo: data.logo,
    is_active: data.is_active,
    powered_by_logo: data.powered_by_logo,
    powered_by_url: data.powered_by_url,
    background: data.background,
    colors: data.colors.app,
    language_configuration: data.language_configuration,
  };
};
